export const SUPER_ADMIN_EMAILS = [
    'suryanshsinghstudy@gmail.com',
    'radieu@gmail.com'
];
